import React from 'react';

export default function Reports() {
    return(
        <div className="Reports">Test content for Reports page</div>
    );
}